import React, { createContext } from 'react';
import { EntitiesDTO } from '../../../DocumentVault.meta';

export interface OrganizeItemsContextValue {
  data?: EntitiesDTO;
  isLoading: boolean;

  destinationPath: string | null;
  setDestinationPath: (destination: string | null) => void;
  sourcePath: string[];
  setSourcePath: (sourcePath: string[]) => void;
  sourceEntities: EntitiesDTO;

  onClose(): void;
  onNext(): void;
  onBack(): void;

  navigatePath: string | null;
  setNavigatePath: (destination: string | null) => void;
}

export const OrganizeItemsContext = createContext<OrganizeItemsContextValue | undefined>(undefined);

interface Props {
  value: OrganizeItemsContextValue;
  children: React.ReactNode;
}

export const OrganizeItemsContextProvider = ({ children, value }: Props) => (
  <OrganizeItemsContext.Provider value={value}>{children}</OrganizeItemsContext.Provider>
);
